import React, { Component } from 'react';
import _ from 'lodash';
import draftToHtml from 'draftjs-to-html';
import { Search } from '../components';
import { withRedux } from '../hoc';
import { getFaqsAction } from '../actions/faqs';

const mapStateToProps = (state) => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    faqs: _.get(state, 'faqs'),
  };
};

const actions = {
  getFaqsAction,
};

@withRedux(mapStateToProps, actions)
export default class Faq extends Component {
  componentDidMount() {
    this.props.actions.getFaqsAction();
  }
  getData = () => {
    return _.orderBy(_.get(this.props, 'faqs.data'), ['sort'], ['asc']);
  };
  render() {
    const { t } = this.props;
    const data = this.getData();
    return (
      <div className="faq-page container-wrapper">
        <div className="search-block">
          <Search.Main />
        </div>
        <div className="main-topic">- {t('Faq')} -</div>
        <div className="content">
          <div className="container">
            <ul className="faq-items">
              {_.map(data, (value, key) => {
                return (
                  <li key={key} className="item">
                    <div className="question">
                      <div className="label">{t('Q')}:</div>
                      <div
                        className="value wysiwyg"
                        dangerouslySetInnerHTML={{
                          __html: draftToHtml(t(_.get(value, 'question'))),
                        }}
                      />
                    </div>
                    <div className="answer">
                      <div className="label">{t('A')}:</div>
                      <div
                        className="value wysiwyg"
                        dangerouslySetInnerHTML={{
                          __html: draftToHtml(t(_.get(value, 'answer'))),
                        }}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Faq.js